export const Icon = (props) => {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg" style={{ width: props.size || '20px', height: props.size || '20px'}}
         width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
         preserveAspectRatio="xMidYMid meet">
        
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" style={{ fill: props.color || 'black'}}
        stroke="none">
        <path d="M1600 5007 c-45 -23 -50 -47 -50 -274 l0 -213 -84 0 c-46 0 -92 -3
        -101 -6 -43 -17 -45 -39 -45 -514 l0 -450 -420 0 c-428 0 -459 -2 -477 -39 -4
        -9 -10 -425 -13 -926 l-5 -909 -193 -141 c-107 -78 -198 -148 -203 -156 -22
        -34 -7 -67 82 -190 123 -169 138 -176 234 -106 33 24 66 47 72 51 10 6 13 -84
        13 -433 l0 -441 -86 0 c-47 0 -94 -4 -104 -10 -24 -13 -41 -65 -31 -93 21 -56
        -159 -52 2463 -52 l2420 0 24 28 c29 34 31 66 4 100 -19 24 -27 26 -113 29
        l-92 3 -3 1166 -2 1166 -23 20 c-12 11 -179 101 -372 199 -192 98 -467 237
        -610 310 l-260 133 -5 611 -5 612 -24 19 c-19 16 -39 19 -112 19 l-89 0 0 219
        c0 218 0 220 -24 248 l-24 28 -859 2 c-676 2 -863 0 -883 -10z m1630 -317 l0
        -170 -760 0 -760 0 0 163 c0 90 3 167 7 170 3 4 345 7 760 7 l753 0 0 -170z
        m230 -1611 l0 -1280 -46 33 c-26 18 -204 149 -398 290 -290 213 -357 257 -384
        258 -28 0 -82 -35 -324 -212 -210 -152 -295 -209 -304 -202 -8 5 -129 92 -269
        194 l-254 185 -1 1008 0 1007 990 0 990 0 0 -1281z m-2140 231 l0 -80 -249 0
        c-236 0 -250 -1 -275 -21 l-26 -20 0 -295 c0 -281 1 -295 20 -314 19 -19 33
        -20 275 -20 l255 0 0 -109 0 -109 -362 -264 c-200 -145 -369 -267 -375 -272
        -10 -6 -13 155 -13 788 l0 796 375 0 375 0 0 -80z m3252 -714 l158 -81 0
        -1127 0 -1128 -555 0 -555 0 0 440 c0 242 2 440 5 440 3 0 29 -17 58 -39 72
        -54 95 -64 128 -57 28 5 29 4 29 -33 0 -24 8 -48 21 -65 l20 -26 293 0 c280 0
        293 1 314 20 22 20 22 25 22 315 l0 294 -26 20 c-26 20 -39 21 -311 21 l-284
        0 -24 -25 c-14 -13 -25 -29 -25 -35 0 -5 -49 26 -110 71 l-110 81 0 700 0 699
        398 -201 c218 -111 468 -239 554 -284z m-3252 299 l0 -175 -195 0 -195 0 0
        175 0 175 195 0 195 0 0 -175z m682 -1126 c326 -238 597 -435 602 -440 4 -4
        -6 -28 -24 -53 l-33 -45 -71 53 c-39 29 -123 90 -186 136 -63 46 -280 204
        -481 351 -202 148 -379 271 -393 275 -34 8 5 34 -624 -425 -287 -209 -526
        -381 -531 -381 -5 0 -21 16 -36 36 -19 25 -25 41 -19 50 10 16 1185 873 1196
        874 5 0 275 -194 600 -431z m1240 -10 c326 -238 595 -433 596 -435 2 -1 -11
        -23 -30 -47 l-34 -45 -294 215 c-162 118 -408 297 -546 398 -138 101 -263 189
        -277 196 -37 17 -47 11 -243 -132 l-166 -121 -41 30 c-23 16 -42 33 -44 38 -4
        13 460 345 474 340 7 -3 279 -200 605 -437z m-1384 -222 l372 -271 0 -503 0
        -503 -215 0 -215 0 0 329 0 330 -24 28 -24 28 -336 3 c-289 2 -340 1 -366 -13
        -16 -8 -31 -17 -32 -18 -1 -1 -5 -155 -8 -342 l-5 -340 -215 0 -215 0 -3 497
        -2 498 122 90 c68 49 255 186 417 304 l294 215 41 -30 c23 -16 209 -152 414
        -302z m1196 23 l405 -295 1 -503 0 -502 -532 2 -533 3 -3 438 c-1 240 0 437 3
        437 3 0 38 -22 77 -50 73 -51 95 -58 129 -40 23 13 186 230 200 267 17 45 -9
        73 -211 221 -107 78 -196 146 -197 150 -4 12 231 179 244 173 6 -3 194 -139
        417 -301z m1296 -305 l0 -175 -175 0 -175 0 0 98 c1 69 5 103 15 116 8 11 15
        32 15 46 0 14 -7 35 -15 46 -32 42 -24 44 160 44 l175 0 0 -175z m-2710 -715
        l0 -280 -235 0 -235 0 0 280 0 280 235 0 235 0 0 -280z"/>
        <path d="M1759 4037 c-36 -28 -39 -51 -39 -322 0 -278 5 -313 45 -329 9 -3
        145 -6 301 -6 l285 0 25 25 25 25 -3 291 -3 291 -24 19 c-22 18 -42 19 -310
        19 -209 -1 -290 -4 -302 -13z m481 -322 l0 -175 -180 0 -180 0 0 175 0 175
        180 0 180 0 0 -175z"/>
        <path d="M2569 4024 c-24 -25 -24 -27 -27 -272 -4 -274 0 -324 29 -353 18 -18
        36 -19 309 -19 l291 0 24 25 25 24 0 286 0 286 -25 24 -24 25 -289 0 -289 0
        -24 -26z m491 -309 l0 -175 -175 0 -175 0 0 175 0 175 175 0 175 0 0 -175z"/>
        <path d="M1759 3217 c-36 -28 -39 -51 -39 -322 0 -278 5 -313 45 -329 9 -3
        145 -6 301 -6 l285 0 25 25 25 25 -3 291 -3 291 -24 19 c-22 18 -42 19 -310
        19 -209 -1 -290 -4 -302 -13z m481 -322 l0 -175 -180 0 -180 0 0 175 0 175
        180 0 180 0 0 -175z"/>
        <path d="M2569 3204 c-24 -25 -24 -27 -27 -272 -4 -274 0 -324 29 -353 18 -18
        36 -19 309 -19 l291 0 24 25 25 24 0 286 0 286 -25 24 -24 25 -289 0 -289 0
        -24 -26z m491 -309 l0 -175 -175 0 -175 0 0 175 0 175 175 0 175 0 0 -175z"/>
        <path d="M3865 2385 l-25 -24 0 -284 c0 -272 1 -285 21 -311 l20 -26 294 0
        c290 0 295 0 315 22 19 21 20 34 20 314 l0 293 -26 20 c-26 20 -39 21 -311 21
        l-284 0 -24 -25z m485 -310 l0 -175 -175 0 -175 0 0 175 0 175 175 0 175 0 0
        -175z"/>
        <path d="M1334 1696 c-62 -20 -110 -61 -139 -119 -78 -156 31 -337 204 -338
        139 -1 235 94 235 231 0 70 -16 113 -63 163 -57 62 -159 89 -237 63z m100
        -157 c36 -17 54 -65 35 -98 -22 -39 -56 -52 -93 -37 -57 23 -60 106 -6 133 31
        16 33 16 64 2z"/>
        </g>
        </svg>)
}